/**
 * Freedom Hero Section JavaScript
 * Handles Swiper initialization for hero banner
 * Desktop: variable width slides (1/3 or full), Mobile: 1 image visible
 */

(function() {
  'use strict';

  let heroSwiper = null;

  function waitForSwiper(callback, maxAttempts) {
    maxAttempts = maxAttempts || 50;
    let attempts = 0;

    function check() {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(check, 100);
      }
    }

    check();
  }

  function initHeroSwiper() {
    const swiperContainer = document.querySelector('.freedom-hero [data-hero-swiper]');
    if (!swiperContainer) return;

    if (swiperContainer.swiper) return;

    const section = swiperContainer.closest('[data-section-id]');

    const swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        stopOnLastSlide: false,
        waitForTransition: true
      },
      pagination: false,
      navigation: {
        nextEl: '.freedom-hero__nav--next',
        prevEl: '.freedom-hero__nav--prev'
      },
      scrollbar: false,
      allowTouchMove: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1
        },
        990: {
          slidesPerView: 'auto',
          spaceBetween: 0
        }
      },
      on: {
        resize: function() {
          this.update();
        },
        slideChange: function() {
          if (this.autoplay && !this.autoplay.running) {
            this.autoplay.start();
          }
        },
        touchEnd: function() {
          var self = this;
          setTimeout(function() {
            if (self.autoplay && !self.autoplay.running) {
              self.autoplay.start();
            }
          }, 100);
        }
      }
    };

    heroSwiper = new Swiper(swiperContainer, swiperConfig);

    var images = swiperContainer.querySelectorAll('img');
    var imagesLoaded = 0;
    var totalImages = images.length;

    if (totalImages === 0) {
      heroSwiper.update();
      return;
    }

    images.forEach(function(img) {
      if (img.complete) {
        imagesLoaded++;
        if (imagesLoaded === totalImages) heroSwiper.update();
      } else {
        img.addEventListener('load', function() {
          imagesLoaded++;
          if (imagesLoaded === totalImages) heroSwiper.update();
        });
        img.addEventListener('error', function() {
          imagesLoaded++;
          if (imagesLoaded === totalImages) heroSwiper.update();
        });
      }
    });
  }

  function destroyHeroSwiper() {
    if (heroSwiper) {
      heroSwiper.destroy(true, true);
      heroSwiper = null;
    }
  }

  function init() {
    waitForSwiper(function() {
      initHeroSwiper();
    });
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (section && section.classList.contains('freedom-hero')) {
      destroyHeroSwiper();
      waitForSwiper(function() { initHeroSwiper(); });
    }
  });

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (heroSwiper) heroSwiper.update();
    }, 250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
